module.exports = __webpack_public_path__ + "img/menu-icon-cross.3e12967b.svg";